
<template>
  <v-app id="inspire">
    <addLocationdialog v-if="isAuthenticated" />
    <SnackBar />

    <v-navigation-drawer
      class='primary'
      :mini-variant.sync="mini"
      v-if="isAuthenticated"
      :permanent='true'
      v-model="drawer"
      width='200'
      :clipped="true"
      dark
      fixed
      app
    >
      <v-list-tile v-if='!mini'>
        <v-list-tile-action>
          <v-icon @click.stop="mini = !mini">chevron_left</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile v-if='mini'>
        <v-list-tile-action>
          <v-icon @click.stop="mini = !mini">chevron_right</v-icon>

        </v-list-tile-action>
      </v-list-tile>
      <v-list dense>

        <template v-for="item in items">
          <v-layout
            v-if="item.heading"
            :key="item.heading"
            row
            align-center
          >
            <v-flex xs6>
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-flex>
          </v-layout>
          <v-list-group
            v-else-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >

            <v-list-tile
              v-for="(child, i) in item.children"
              :key="i"
              @click="routeTo(item)"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ child.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile
            v-else
            :key="item.text"
            @click="routeTo(item)"
          >
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar
      :clipped-left="true"
      color="white"
      app
      fixed
    >
      <v-toolbar-title>
        <img
          :src='config.webconfig.appBarLogo'
          width="50%"
        />
      </v-toolbar-title>

      <v-text-field
        light
        prepend-inner-icon="search"
        v-if="isAuthenticated"
        v-model="searchBarText"
        solo
        label="Search"
        @keyup.enter.native="onEnter(searchBarText)"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        class="secondary"
        title="Download ISO file"
        @click="downloadISO"
        v-if="isAuthenticated"
        icon
      >
        <v-icon>info</v-icon>
      </v-btn>
      <v-btn
        class="secondary"
        title="Download PXE server file"
        @click="downloadPXE"
        v-if="isAuthenticated"
        icon
      >
        <v-icon>storage</v-icon>
      </v-btn>
      <v-btn
        class="secondary"
        title="Download WIM file"
        @click="downloadWim"
        v-if="isAuthenticated"
        icon
      >
        <v-icon>desktop_windows</v-icon>
      </v-btn>
      <v-btn
        class="secondary"
        title="Download Discovery Tool"
        @click="downloadEXE"
        v-if="isAuthenticated"
        icon
      >
        <v-icon>cloud_download</v-icon>
      </v-btn>
      <v-btn
        @click="routeToNonObject('/settings')"
        v-if="isAuthenticated"
        icon
      >
        <v-icon>settings</v-icon>
      </v-btn>
      <v-btn
        @click="logout()"
        v-if="isAuthenticated"
        icon
      >
        <v-icon>logout</v-icon>
      </v-btn>
    </v-toolbar>

    <v-content>

      <router-view />
      <v-speed-dial
        v-if="isAuthenticated"
        v-model="fab"
        :bottom="true"
        :right="true"
        direction="top"
        :open-on-hover="false"
        transition="slide-y-reverse-transition"
        fixed
      >
        <template v-slot:activator>
          <v-btn
            v-model="fab"
            color="blue darken-2"
            dark
            fab
          >
            <v-icon>add</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
        </template>
        <v-btn
          fab
          dark
          small
          color="green"
          @click='Adddialog = true, assetToAdd="Computer"'
          title='Add Computer'
        >
          <v-icon>computer</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          small
          color="indigo"
          @click='Adddialog = true, assetToAdd="Monitor"'
          title='Add Monitor'
        >
          <v-icon>desktop_windows</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          small
          color="red"
          @click='Adddialog = true, assetToAdd="Phone"'
          title='Add phone'
        >
          <v-icon>smartphone</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          small
          color="purple"
          @click='addLocationdialog = true'
          title='Add Location'
        >
          <v-icon>location_on</v-icon>
        </v-btn>
      </v-speed-dial>
      <addAssetTitle
        v-on:Adddialogclose="Adddialog = false"
        :assetType="assetToAdd"
        v-if="Adddialog"
      />
    </v-content>
  </v-app>
</template>
 
<script>
import addAssetTitle from "./components/addAssetsType";
import addLocationdialog from "./components/addLocationDialog"
import { mapFields } from "vuex-map-fields";
import config from "./firebaseIDs";
import SnackBar from './components/SnackBar'
const fb = require("./firebaseConfig.js");
export default {
  name: "APP",
  components: {
    addLocationdialog,
    SnackBar,
    addAssetTitle
  },
  data: () => ({
    config: config,
    assetToAdd: "",
    Adddialog: false,
    fab: false,
    mini: true,
    searchBarText: null,
    isLoading: false,
    search: null,
    drawer: null,
    autoCompResult: [],
    items: [
      { icon: "home", text: "Home", route: "/home" },
      { icon: "search", text: "Inventory", route: "/inventory" },
      { icon: "location_on", text: "Locations", route: "/location" },
      { icon: "grid_on", text: "Lots", route: "/lots" },
      { icon: "print", text: "Labels", route: "/createLabel" },
      { icon: "people", text: "Clients", route: "/clients" },
      { icon: "delete", text: "Recycle Bin", route: "/recycle" },
      { icon: "cloud_download", text: "Download   ", route: "/download" },
      { icon: "help_outline", text: "Help", route: "" }
    ]
  }),
  mounted () {
    fb.auth.onAuthStateChanged(user => {
      if (!user) {
        this.isAuthenticated = false;
      } else {
        this.isAuthenticated = true;
      }
    });
  },
  watch: {
    search (text) {
      // Items have already been loaded
      if (this.autoCompResult.length > 0) return;
      // Items have already been requested
      if (this.isLoading) return;

      this.isLoading = true;
      fb.AssetsCollections.where("Discovery.AssetTag", "==", text).get()
        .then(docs => {
          docs.forEach(doc => {
            this.autoCompResult.push(doc.data());
          });
        })
        .catch(err => {
          return err;
        })
        .finally(() => (this.isLoading = false));
    }
  },
  created () { },
  props: {
    source: String
  },
  computed: {
    ...mapFields([
      "addLocationdialog",
      "imageURL",
      "settings",
      "currentCount",
      "isAuthenticated",
      "user"
    ])
  },
  methods: {

    downloadFile (url) {
    var gsReference = fb.storage.refFromURL(
        url
      );
      gsReference.getDownloadURL().then(url => {
        window.open(url, "_blank");
      });
    },
    downloadISO () {
    this.downloadFile(this.config.webconfig.iso)
    },
    downloadPXE () {
    this.downloadFile(this.config.webconfig.pxeserver)
    },
    downloadWim () {
      this.downloadFile(this.config.webconfig.bootwim)
    },
    downloadEXE () {
      this.downloadFile(this.config.webconfig.desktopApp)
    },
    logout () {
      fb.auth.signOut().then(() => {
        this.user = null;
        this.isAuthenticated = false;
        this.$router.push("/");
      });
    },
    routeToNonObject (url) {
      this.$router.push(url);
    },
    routeTo (item) {
      if (item.text === "Help") {
        window.open("https://techreusestaff.gitbook.io/workspace/");
        return;
      }

      this.$router.push(item.route);
    },
    onEnter (input) {
      if (input === null) {
        return;
      }
      this.$router.push({ name: "Assets with id", params: { id: input } });
    }
  }
};
</script>